<script>
import Vue from 'vue';

var myMixin = {
  computed: {
    error: function () {
      var _this = this;
      var error = '';

      if (this.errors == undefined)
        return '';

      this.errors.map(function(err) {
        if (err.id == _this.id)
          error = err;
      });

      if (error != '') {
        return error.msg;
      } else {
        return '';
      }
    }
  }
}

Vue.component('ajaxLoaderButton', {
  props: ['label','iconclass','onClick','value'],
  data: function() {
    return {
      className: 'fl-button',
      guid: ''
    };
  },
  template: '<button :id="id" :disabled=value :class="className" type="button" v-on:click="click"><i :class="iconclass"></i>{{ label }}</button>',
  mounted: function() {
  },
  watch: {
    value: function(newval, oldval) {
      if (newval) {
        this.className = 'fl-button with-preloader';
        $.fn.spin.presets.preloader = {lines:13, length:0, width:3, radius:10, scale:.75, corners:1, opacity:.25, speed:1};
        $('#'+this.guid).spin('preloader');
      } else if (!newval) {
        this.className = 'fl-button';
        $('#'+this.guid).spin(false);
      }
    }
  },
  computed: {
    id: function() {
      this.guid = this.generateGUID();
      return this.guid;
    }
  },
  methods: {
    generateGUID: function() {
        function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    },
    click: function() {
      this.onClick();
    }
  }
});

Vue.component('inputbox', {
  mixins: [myMixin],
  data: function() {
    return {
      local_value: 0,
      flatpickr: '',
      flatpickr_opts: {}
    };
  },
  props: {
    label: {
      type: String,
      required: false
    },
    value: {
      validator: prop => typeof prop === 'string' || typeof prop === 'number' || prop === null,
      required: true
    },
    errors: {
      type: Array,
      required: false
    },
    id: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    disabled: {
      type: [Boolean, Number],
      required: false
    },
    maxlength: {
      type: [Number, String],
      required: false
    },
    regexp_filter: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    autocomplete: {
      type: String,
      required: false
    },
    datepicker: {
      type: Object,
      required: false
    }
  },
  template: `<div class="form-group" :style="label ?'': 'padding-bottom: 0px'" v-bind:class="{error: error.length}">
		<label v-if="label" class="form-label">{{ label }}</label>
            <input :id="id" class="form-control"
                             :name="name"
                             :disabled="disabled"
														 :ref="id"
													   type="text"
                             :maxlength="maxlength"
                             :autocomplete="autocomplete"
                             :placeholder="placeholder"
                             @keyup="keyup"
													   v-model="local_value"
                             @keydown.enter.prevent="keydownEnter"
                             @input="change">

		<div v-if="error.length" class="form-error">{{ error }}</div>
	</div>`,
  watch: {
    value: function() {
      this.local_value = this.value;

      if (this.flatpickr != '') {
        this.flatpickr.setDate(this.local_value);
      }
    }
  },
  mounted: function() {
    var _this = this;
    this.local_value = this.value;

    if (this.datepicker != undefined && this.id != undefined) {
      const flatpickr = require('flatpickr');
      const Hungarian = require('flatpickr/dist/l10n/hu.js').default.hu;

      this.flatpickr_opts = {
        time_24hr: true,
        defaultDate: this.local_value,
        locale: 'hu',
        onClose: function(selectedDates, dateStr, instance) {
          _this.updateValue(dateStr);
        },
        onChange: function(selectedDates, dateStr, instance) {
          _this.updateValue(dateStr);
        }
      };

      this.flatpickr_opts = $.extend(this.flatpickr_opts, this.datepicker);

      Vue.nextTick(function() {
        _this.flatpickr = flatpickr($('#' + _this.id), _this.flatpickr_opts);
      });
    }

    if (this.regexp_filter != undefined && this.regexp_filter != '') {
      Vue.nextTick(function() {
        $('#' + _this.id).inputmask('Regex', {regex: _this.regexp_filter, oncleared: function() { _this.updateValue($(this).val()); }, onincomplete: function() { _this.updateValue($(this).val()); }, oncomplete: function() { _this.updateValue($(this).val()); }});
      });
    }
  },
	methods: {
    keydownEnter: function() {
      this.$emit('keydownEnter', this.local_value);
    },

    change: function() {
      this.$emit('input', this.local_value);
    },

    keyup: function() {
      this.$emit('keyup', this.local_value);
    },

    reinitFlatpickr: function() {
      this.flatpickr = flatpickr($('#' + this.id), this.flatpickr_opts);
    },

    updateValue: function (value) {
      this.local_value = value;
      this.$emit('input', this.local_value);
    }
  }
});

Vue.component('textareabox', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name','disabled','cstyle'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
            <textarea :id="id" class="form-control" v-bind:name="name"\
                             v-bind:style="cstyle"\
                             v-bind:disabled="disabled"\
														 ref="input"\
													   v-bind:value="value"\
														 v-on:input="updateValue($event.target.value)">\
                             </textarea>\
		<div v-if="error.length" class="form-error">{{ error }}</div>\
	</div>',
	methods: {
    updateValue: function (value) {
      this.$emit('input', value);
    }
  }
});

Vue.component('passwordbox', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name','keyup','keydownEnter'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
            <input :id="id" class="form-control" v-bind:name="name"\
														 ref="input"\
													   type="password"\
													   v-bind:value="value"\
                             v-on:keyup="onKeyup"\
                             v-on:keydown.enter.prevent="onKeydownEnter"\
														 v-on:input="updateValue($event.target.value)">\
		<div v-if="error.length" class="form-error">{{ error }}</div>\
	</div>',
	methods: {
    onKeydownEnter: function() {
      if (this.keydownEnter != undefined)
        this.keydownEnter();
    },
    updateValue: function (value) {
      this.$emit('input', value);
    },
    onKeyup: function() {
      if (this.keyup != undefined)
        this.keyup(this.value);
    }
  }
});

Vue.component('checkbox', {
  mixins: [myMixin],
  data: function() {
    return {
      local_value: 0
    };
  },
  props: ['label','value','errors','id','name','disabled','val'],
  template: `<div class="form-group" v-bind:class="{error: error.length}">
    <div :class="{disabled: disabled}" class="checkbox"><input @change="change" :id="id" v-bind:name="name"
														 v-model="local_value"
													   type="checkbox"
                             :disabled="disabled"
													   v-bind:value="val"><label :for="id">{{ label }}</label></div>
	  <div v-if="error.length" class="form-error">{{ error }}</div>
	</div>`,
  watch: {
    value: function() {
      this.local_value = this.value;
    }
  },
  mounted: function(){
    this.local_value = this.value;
  },
  methods: {
    change: function() {
      this.$emit('input', this.local_value);
    }
  }
});

Vue.component('radio', {
  mixins: [myMixin],
  data: function() {
    return {
      local_value: 0
    };
  },
  props: ['label','val','value','errors','id','name','disabled'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
    <div :class="{disabled: disabled}" class="radio"><input @change="change" :id="id" v-bind:name="name"\
														 v-model="local_value"\
													   type="radio"\
                             :disabled="disabled"\
													   v-bind:value="val"><label :for="id">{{ label }}</label></div>\
	  <div v-if="error.length" class="form-error">{{ error }}</div>\
	</div>',
  watch: {
    value: function() {
      this.local_value = this.value;
    }
  },
  mounted: function(){
    this.local_value = this.value;
  },
  methods: {
    change: function() {
      this.$emit('input', this.local_value);
    }
  }
});

Vue.component('toggle', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
            <div><input :id="id" style="display:none" v-bind:name="name"\
														 v-model="value.selected"\
													   type="checkbox"\
													   v-bind:value="value.value">\
<div class="toggle-wrapper"><div v-on:click="toggle" class="toggle" v-bind:class="{active}"><div class="toggle-slide"><div class="toggle-inner"><div class="toggle-on">Igen</div><div class="toggle-blob"></div><div class="toggle-off">Nem</div></div></div></div></div>\
</div>\
	  <div v-if="error.length" class="form-error">{{ error }}</div>\
	</div>',
  computed: {
    active: function() {
      return this.value.selected ? "active" : "";
    }
  },
  methods: {
    toggle: function() {
      this.value.selected = !this.value.selected;
    }
  }
});

Vue.component('toggleV2', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name','v'],
  data: function() {
    return {
      selected: 0
    };
  },
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
            <div><input :id="id" style="display:none" v-bind:name="name"\
														 v-model="selected"\
													   type="checkbox"\
													   v-bind:value="v">\
<div class="toggle-wrapper"><div v-on:click="toggle" class="toggle" v-bind:class="{active}"><div class="toggle-slide"><div class="toggle-inner"><div class="toggle-on">Igen</div><div class="toggle-blob"></div><div class="toggle-off">Nem</div></div></div></div></div>\
</div>\
	  <div v-if="error.length" class="form-error">{{ error }}</div>\
	</div>',
  mounted: function() {
    this.selected = this.value;
  },
  computed: {
    active: function() {
      return this.selected == 1 ? "active" : "";
    }
  },
  methods: {
    toggle: function() {
      this.selected = this.selected == 1 ? 0 : 1;
      this.$emit('input', this.selected);
    }
  }
});

Vue.component('checkboxes', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
		<div v-for="(v, index) in value.items">\
		  <div class="checkbox"><input :id="inputid(index)" v-bind:value="v.value"\
										v-bind:name="name"\
										v-model="value.selected"\
										type="checkbox"><label :for="inputid(index)">{{ v.label }}</label>\
      </div>\
		</div>\
		<div v-if="error.length" class="form-error">{{ error }}</div>\
	</div>',
  methods: {
    inputid: function(index) {
      return this.name + "_" + index;
    }
  }
});

Vue.component('checkboxesV2', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name','items'],
  data: function() {
    return {
      ids: []
    };
  },
  template: `
    <div class="form-group checkboxgroup" v-bind:class="{error: error.length}">
      <label class="form-label">{{ label }}</label>
      <div v-for="(item, index) in items">
        <div class="checkbox"><input v-model="ids" v-on:change="change" :id="inputid(index)" :value="item.value" :name="name+'[]'" type="checkbox"><label :for="inputid(index)">{{ item.label }}</label>
      </div>
		</div>
		<div v-if="error.length" class="form-error">{{ error }}</div>
	</div>`,
  watch: {
    value: function() {
      this.ids = this.value;
    }
  },
  mounted: function() {
    this.ids = this.value;
  },
  methods: {
    change: function() {
      this.$emit('input', this.ids);
    },
    inputid: function(index) {
      return this.name + "_" + index;
    }
  }
});

Vue.component('radios', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name'],
  template: '<div v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
		<div v-for="(v, index) in value.items">\
			<div class="radio"><input :id="inputid(index)" v-bind:index="index"\
										v-bind:value="v.value"\
										v-bind:name="name"\
										v-model="value.selected"\
										type="radio"><label :for="inputid(index)">{{ v.label }}</label>\
      </div>\
		</div>\
		<div v-if="error.length" class="form-error">{{ error }}</div>\
	</div>',
  methods: {
    inputid: function(index) {
      return this.name + "_" + index;
    }
  }
});

Vue.component('combobox', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name','change','disabled'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
			<select v-bind:disabled="disabled" v-on:change="onChange(value.selected)" class="form-control" v-bind:name="name" v-bind:id="id" v-model="value.selected">\
				<option v-for="item in value.items" v-bind:value="item.value">{{item.label}}</option>\
			</select>\
		<div v-if="error.length" class="form-error">{{ error }}</div>\
	</div>',
  methods: {
    onChange: function(val) {
      if (this.change != undefined)
        this.change(val);
    }
  }
});

Vue.component('comboboxV2', {
  mixins: [myMixin],
  data: function() {
    return {
      v: 0
    };
  },
  props: ['label','value','errors','id','name','change','disabled','options'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
			<select v-bind:disabled="disabled" class="form-control" v-on:change="onChange" v-bind:name="name" v-bind:id="id">\
				<option :selected="v == o.value" v-for="o in options" v-bind:value="o.value">{{o.label}}</option>\
			</select>\
		<div v-if="error.length" class="form-error">{{ error }}</div>\
	</div>',
  watch: {
    value: function(nv, ov) {
      if (nv != undefined) {
        this.v = nv;
      }
    }
  },
  mounted: function() {
    this.v = this.value;
  },
  methods: {
    onChange: function() {
      this.v = $('#'+this.id).val();

      if (this.v != undefined) {
        this.$emit('input', this.v);

        if (this.change != undefined)
          this.change(this.v);
      }
    },
  }
});

Vue.component('mutipleComboboxV2', {
  mixins: [myMixin],
  data: function() {
    return {
      v: []
    };
  },
  props: ['label','value','errors','id','name','change','disabled','options'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
			<select style="height: 200px" multiple="multiple" v-bind:disabled="disabled" class="form-control" v-on:change="onChange" v-bind:name="name" v-bind:id="id">\
				<option :selected="inArray(o.value)" v-for="o in options" v-bind:value="o.value">{{o.label}}</option>\
			</select>\
		<div v-if="error.length" class="form-error">{{ error }}</div>\
	</div>',
  watch: {
    value: function(nv, ov) {
      if (nv != undefined) {
        this.v = nv;
      }
    }
  },
  mounted: function() {
    this.v = this.value;
  },
  methods: {
    inArray: function(value) {
      var found = false;

      this.v.map(function(array_v) {
        if (value == array_v)
          found = true;
      });

      return found;
    },
    onChange: function() {
      this.v = $('#'+this.id).val();

      if (this.v != undefined) {
        this.$emit('input', this.v);

        if (this.change != undefined)
          this.change(this.v);
      }
    },
  }
});

Vue.component('select2', {
  mixins: [myMixin],
  props: ['label','value','errors','id','options','name','multi','change','disabled','placeholder','allowClear'],
  template: `<div class="form-group" v-bind:class="{error: error.length}">
		<label class="form-label">{{ label }}</label>
    <select v-model="v" style="width: 100%" :disabled="disabled" :multiple="multiple" class="form-control select2js" :name="name" :id="id">
      <option v-for="option in options" v-bind:value="option.value" v-bind:disabled="option.disabled">{{ option.label }}</option>
    </select>
    <div v-if="error.length" class="form-error">{{ error }}</div>
	</div>`,
  data: function() {
    return {
      v: this.multi == "true" ? [] : ''
    }
  },
  watch: {
    'value': {
      handler: function() {
        this.v = this.value;
        $('#' + this.id).val(this.v).trigger("change");
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    init: function() {
      var _this = this;
      _this.v = _this.value;

      $('#' + _this.id).select2({
        tags: true,
        language: "hu",
        placeholder: _this.placeholder,
        allowClear: _this.allowClear
      })
      .on("select2:select", function (e) {
        _this.v = $('#' + _this.id).val();

        // Megnézi, hogy bent van -e a választás az opciói között
        var in_opts = false;
        _this.options.map(function(opt) {
          if (opt.value == _this.v)
            in_opts = true;
        });
        if (!in_opts && _this.multi == undefined) {
          _this.v = _this.options[0].value;
          $('#' + _this.id).val(_this.v).trigger("change");
        }

        if (_this.multi == "true") {
          var tmp = [];
          _this.v.map((v) => {
            var in_opts = false;
            _this.options.map(function(opt) {
              if (parseInt(opt.value) == parseInt(v)) {
                in_opts = true;
              }
            });
            if (in_opts) {
              tmp.push(v);
            }
          });
          _this.v = tmp;
          $('#' + _this.id).val(_this.v).trigger("change");
        }

        _this.$emit('input', _this.v);
        _this.$emit('onChange', _this.v);
      })
      .on("select2:unselect", function (e) {
        _this.v = $('#' + _this.id).val();
        _this.$emit('input', _this.v);
        _this.$emit('onChange', _this.v);
      })
      .on("select2:unselecting", function (e) {
        _this.v = $('#' + _this.id).val();
        _this.$emit('input', _this.v);
        _this.$emit('onChange', _this.v);
        setTimeout(function() {
          $('#' + _this.id).select2('close');
        }, 0);
      });
    },
    refresh: function() {
      $('#' + this.id).select2({ data:this.v });
    },
    reload: function() {
      $('#' + this.id).select2('destroy');
      this.init();
    }
  },
  mounted: function() {
    this.init();
  },
  computed: {
    multiple: function() {
      return this.multi == "true" ? true : false;
    }
  }
});

Vue.component('select2ajax', {
  mixins: [myMixin],
  props: ['label','value','errors','id','name','multi','change','disabled','url','method'],
  template: '<div class="form-group" v-bind:class="{error: error.length}">\
		<label class="form-label">{{ label }}</label>\
			<select v-bind:disabled="disabled" :multiple="multiple" class="form-control select2js" v-bind:name="name" v-bind:id="id" v-model="value.selected">\
				<option v-for="item in value.items" v-bind:value="item.value">{{item.label}}</option>\
			</select>\
    <div v-if="error.length" class="form-error">{{ error }}</div>\
	</div>',
  mounted: function() {
    var _this = this;

    Vue.nextTick(function() {
      _this.addPlugin();
    });
  },
  computed: {
    multiple: function() {
      return this.multi == "true" ? true : false;
    }
  },
  methods: {
    addPlugin: function() {
      var _this = this;
      $('#'+this.id).select2({
        placeholder: 'Kezdjen el írni...',
        ajax: {
          url: 'api/'+this.url,
          dataType: 'json',
          delay: 250,
          method: this.method,
          data: function (params) {
            return {
              q: params.term,
              page: params.page
            };
          },
          processResults: function (data, params) {
            return {
              results: data.items
            };
          },
          cache: true
        },
        escapeMarkup: function (markup) {
          return markup;
        },
        minimumInputLength: 2
      }).on("select2:select", function (e) {
        _this.value.selected = $('#'+_this.id).val();
        if (_this.change != undefined)
          _this.change(_this.value.selected);
      })
      .on("select2:unselect", function (e) {
        _this.value.selected = $('#'+_this.id).val();
        if (_this.change != undefined)
          _this.change(_this.value.selected);
      });
    }
  },
  watch: {
    url: function(nv, ov) {
      if (nv != ov) {
        $('#' + this.id).select2('destroy');
        this.addPlugin();
      }
    }
  }
});

Vue.component('pagination', {
  props: ['limit','amount','value','showcombo','compact'],
  data: function() {
     return {
         page: parseInt(this.value),
         from: 1,
         to: 0,
         pagec: 0
     };
  },
  template: '<section>\n\
<div class="pagination-text">Összesen {{ amount }} találat, {{ pagec }} lapon.</div>\n\
<ul class="pagination">\n\
  <li v-if="showcombo"><select v-model="page" v-on:change="comboChange" class="form-control"><option v-for="i in comboIndex" v-bind:value="i">{{i}}</option></select></li>\n\
  <li><a v-on:click="firstClick" href="javascript:void(0)" aria-label="Első"><span aria-hidden="true"><i class="fa fa-angle-double-left"></i></span></a></li>\n\
  <li><a v-on:click="prevClick()" href="javascript:void(0)" aria-label="Előző"><span aria-hidden="true"><i class="fa fa-angle-left"></i></span></a></li>\n\
  <li v-if="!compact" v-for="i in renderLiIndex" v-bind:class="{active: i == page}"><a v-on:click="pageClick(i)" href="javascript:void(0)">{{ i }}</a></li>\n\
  <li><a v-on:click="nextClick" href="javascript:void(0)" aria-label="Következő"><span aria-hidden="true"><i class="fa fa-angle-right"></i></span></a></li>\n\
<li><a v-on:click="lastClick" href="javascript:void(0)" aria-label="Utolsó"><span aria-hidden="true"><i class="fa fa-angle-double-right"></i></span></a></li>\n\
</ul>\n\
</section>',
  mounted: function() {
    this.calcToFrom();
  },
  computed: {
    renderLiIndex: function() {
      var arr = [];
      for (var i = this.from; i <= this.to; i++) {
        arr.push(i);
      }
      return arr;
    },
    comboIndex: function() {
      var arr = [];
      for (var i = 1; i <= this.pagec; i++) {
        arr.push(i);
      }
      return arr;
    }
  },
  watch: {
    value: function(newval, oldval) {
      this.page = parseInt(newval);
      this.calcToFrom();
    },
    page: function(newval, oldval) {
      this.page = parseInt(newval);
      this.calcToFrom();
    },
    amount: function(newval, oldval) {
      this.calcToFrom();
    },
    limit: function(newval, oldval) {
      this.calcToFrom();
    }
  },
  methods: {
    calcToFrom: function() {
      var amount = parseInt(this.amount);
      var limit =  parseInt(this.limit);
      this.pagec = Math.ceil(amount / limit);

      if (this.page > this.pagec)
        this.page = this.pagec;

      if (this.page < 1)
        this.page = 1;

      var page = parseInt(this.page);
      var from = parseInt(this.from);
      var to = parseInt(this.to);

      if (this.pagec >= 7) {
        if (page - 3 <= 1) {
          this.from = 1;
          this.to = from + 6;

        } else if (page + 3 <= this.pagec) {
          this.from = page - 3;
          this.to = page + 3;
        } else {
          var extra = (page + 3) - this.pagec;
          this.from = (page - 3) - extra;
          this.to = this.pagec;
        }
      } else {
        this.from = 1;
        this.to = this.pagec;
      }
    },
    comboChange: function() {
      this.$emit('pageChanged', this.page);
    },
    pageClick: function(page) {
      this.page = page;
      this.$emit('pageChanged', page);
    },
    prevClick: function() {
      if (this.page > 1)
        this.page = this.page - 1;

      this.$emit('pageChanged', this.page);
    },
    nextClick: function() {
      if ((parseInt(this.page) + 1) > this.pagec) {
        this.page = this.pagec;
      } else {
        this.page = parseInt(this.page) + 1;
      }
      this.$emit('pageChanged', this.page);
    },
    lastClick: function() {
      this.page = this.pagec;
      this.$emit('pageChanged', this.page);
    },
    firstClick: function() {
      this.page = 1;
      this.$emit('pageChanged', this.page);
    }
  },
});

Vue.component('ProgressInfo', {
  props: {
    text: {
      type: String,
      required: false
    },
    show: {
      type: Boolean,
      required: true
    },
  },
  data: function() {
    return {
      textd: (this.text == undefined ? 'Kérem várjon' : this.text),
      textwd: (this.text == undefined ? 'Kérem várjon' : this.text),
      interval: '',
      dots: 0
    };
  },
  template: `
    <div class="save-progess-bar">
      <img src="assets/img/preloader.png" alt=""/>{{ textwd }}
    </div>
  `,
  watch: {
    show: function(nv, ov) {
      var _this = this;
      if (nv) {
        $('.save-progess-bar').addClass('show');
        this.interval = setInterval(this.animation, 150);
      } else {
        $('.save-progess-bar').removeClass('show');
        clearInterval(this.interval);
      }
    }
  },
  methods: {
    animation: function() {
      /*
      if (this.dots == 5) {
        this.dots = 0;
        this.textwd = this.textd;
      } else {
        this.textwd = this.textwd + '.';
        this.dots++;
      }*/
    }
  }
});

var Tabulator = require("tabulator-tables");
Vue.component('TabulatorTable', {
  props: {
    value: {
      type: Array,
      required: true
    },
    options: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      tabulator: null,
      v: []
    }
  },
  watch:{
    value:{
      handler: function() {
        this.v = this.value;
        this.tabulator.replaceData(this.v);
      },
      deep: true
    }
  },
  methods: {

  },
  mounted: function() {
    const _this = this;

    var options = {
      autoResize: false,
      layout: "fitColumns",
      reactiveData: true,
      layoutColumnsOnNewData: true,
      resizableColumns: true,
      resizableRows: false,
      locale: false,
      headerFilterPlaceholder: '',
      pagination: "local",
      paginationSize: 100,
      paginationSizeSelector:[25, 50, 100, 200],
      placeholder: "Adatok töltése...",
      langs: {
        "hu": {
          "pagination": {
            "first": "<i class='fa fa-angle-left'/><i class='fa fa-angle-left'/>",
            "first_title":"Első",
            "last":"<i class='fa fa-angle-right'/><i class='fa fa-angle-right'/>",
            "last_title":"Utolsó",
            "prev":"<i class='fa fa-angle-left'/>",
            "prev_title":"Előző",
            "next":"<i class='fa fa-angle-right'/>",
            "next_title":"Következő",
            "page_size": "Találat / oldal"
          }
        }
      }
    };

    options = $.extend(options, this.options);

    this.v = this.value;
    options.data = this.v;

    this.tabulator = new Tabulator(this.$refs.table, options);
    this.tabulator.setLocale("hu");
  },
  template: '<div ref="table"></div>'
});
</script>



// WEBPACK FOOTER //
// components.vue?3445b772